import { render, staticRenderFns } from "./PackageListItem.vue?vue&type=template&id=e6d30256&scoped=true&"
import script from "./PackageListItem.vue?vue&type=script&lang=js&"
export * from "./PackageListItem.vue?vue&type=script&lang=js&"
import style0 from "./PackageListItem.vue?vue&type=style&index=0&id=e6d30256&scoped=true&lang=less&"
import style1 from "./PackageListItem.vue?vue&type=style&index=1&id=e6d30256&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6d30256",
  null
  
)

export default component.exports